// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"IW-z","sponsoredTooltipWrapper":"JW-z","sponsoredTooltip":"KW-z","newCard":"LW-z"};